import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";

const bannerItems = [
    {
        title: 'MADE IN BRITAIN',
        subtitle: 'to your exact specification'
    },
    {
        title: '15 YEARS IN BUSINESS',
        subtitle: 'guaranteeing prefect delivery'
    },
    {
        title: 'BUILT TO ORDER',
        subtitle: 'made in less than 2 weeks'
    },
    {
        title: '5 YEAR GUARANTEE',
        subtitle: 'for complete peace of mind'
    }
];

export default function BannerFullWidth() {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        // Set up an interval to cycle through the items
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % bannerItems.length);
        }, 1500); // Change item every 3 seconds

        // Clean up the interval when the component unmounts
        return () => clearInterval(interval);
    }, []); // Empty dependency array ensures this effect runs only once on mount

    return (
        <Box sx={{ backgroundColor: 'rgb(22, 161, 216)', overflow: 'hidden' }}>
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center', color: '#FFF' }} p={3}>
                <Grid container sx={{ flex: 1, display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                    {bannerItems.map((bannerItem, index) => (
                        <Grid 
                            item 
                            key={index} 
                            size={{xs: 12, sm:6, md:3}} // Make it responsive
                            sx={{
                                display: 'flex',
                                justifyContent: 'center', // Corrected 'centre' to 'center'
                                alignItems: 'center',
                                textAlign: 'center',
                                flexDirection: 'column',
                                padding: 2,
                                // Add transition for a smooth effect
                                transition: 'transform 0.5s ease-in-out, text-shadow 0.5s ease-in-out',
                                // Conditionally apply the "glow" effect
                                transform: activeIndex === index ? 'scale(1.15)' : 'scale(1)',
                                textShadow: activeIndex === index ? '0 0 12px rgba(255, 255, 255, 0.7)' : 'none',
                            }}
                        >
                            <Typography variant="h4" fontWeight={'bold'}>
                                {bannerItem.title}
                            </Typography>
                            <Typography variant="h6">
                                {bannerItem.subtitle}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}